import VProgressCircular from './VProgressCircular';
export { VProgressCircular };
export default VProgressCircular;
//# sourceMappingURL=index.js.map